document.addEventListener("DOMContentLoaded", function () {

  const btn = document.getElementById("hero-search-btn");

  if (!btn) return;

  btn.addEventListener("click", function () {

    const marca = document.getElementById("search-marca").value.trim();
    const modelo = document.getElementById("search-modelo").value.trim();
    const anio = document.getElementById("search-anio").value.trim();
    const parte = document.getElementById("search-parte").value.trim();

    let queryParts = [];

    if (marca) queryParts.push(marca);
    if (modelo) queryParts.push(modelo);
    if (anio) queryParts.push(anio);
    if (parte) queryParts.push(parte);

    if (queryParts.length === 0) return;

    const finalQuery = queryParts.join(" ");

    window.location.href = `/search?q=${encodeURIComponent(finalQuery)}`;
  });

});

document.addEventListener("DOMContentLoaded", () => {

  const tabs = document.querySelectorAll(".search-tab")
  const contents = document.querySelectorAll(".search-tab-content")

  tabs.forEach(tab=>{
    tab.addEventListener("click",()=>{

      tabs.forEach(t=>t.classList.remove("active"))
      contents.forEach(c=>c.classList.remove("active"))

      tab.classList.add("active")

      const target = tab.dataset.tab

      document
        .querySelector(`[data-content="${target}"]`)
        .classList.add("active")
    })
  })


  /* BUSQUEDA GENERAL */

  const generalBtn = document.getElementById("general-search-btn")

  if(generalBtn){
    generalBtn.addEventListener("click",()=>{

      const query = document
        .getElementById("search-general")
        .value
        .trim()

      if(!query) return

      window.location.href = `/search?q=${encodeURIComponent(query)}`
    })
  }

})
